import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CountryExtraFields = ({ fields, values, onChange, countryName }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [touchedFields, setTouchedFields] = useState({})

  const getFieldValue = (field, rawValue) => (field.getValue ? field.getValue(rawValue) : rawValue)

  const handleChange = (field, value) => {
    const formattedValue = field.formatOnChange ? field.formatOnChange(value) : value
    onChange(field.key, formattedValue)
  }

  const handleBlur = field => {
    setTouchedFields(prev => ({ ...prev, [field.key]: true }))
  }

  const isMissing = field => field.isMissing(getFieldValue(field, values?.[field.key]))

  const getError = field => {
    if (isMissing(field)) return true
    if (!touchedFields[field.key] || !field.validate) return false

    return !!field.validate(getFieldValue(field, values?.[field.key]) || '')
  }

  const getLabelError = field => !isMissing(field) && getError(field)

  const getHelperText = field => {
    if (isMissing(field)) return t(field.warning, { country: countryName })

    const value = getFieldValue(field, values?.[field.key]) || ''
    const touched = touchedFields[field.key]

    if (field.getHelperText) return t(field.getHelperText(value, touched))

    return undefined
  }

  return fields.map(field => (
    <InputWithLabel
      key={field.key}
      label={t(field.label)}
      type={field.type}
      value={field.disabled ? '' : getFieldValue(field, values?.[field.key]) || ''}
      onChange={e => handleChange(field, e.target.value)}
      onBlur={() => handleBlur(field)}
      backgroundColor={theme.colors.background.primary}
      maxLength={field.maxLength}
      startAdornment={
        field.startAdornment ? (
          <Styles.StartAdornment type="bodyMRegular">{field.startAdornment}</Styles.StartAdornment>
        ) : undefined
      }
      showCounter={field.showCounter}
      disabled={field.disabled}
      error={getError(field)}
      InputLabelProps={{ error: getLabelError(field), focused: isMissing(field) ? false : undefined }}
      helperText={getHelperText(field)}
      fullWidth
    />
  ))
}

export default CountryExtraFields
